"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateOrderDeliveryStatus = exports.makeUpdateDeliveryStatusUrl = exports.makeUpdateOrderReviewScore = exports.makeCustomerOrderFeedbackUrl = exports.requestCustomerOrderBff = exports.CUSTOMER_ORDERS_URL = exports.VD_CUSTOMER_ORDER_BFF = void 0;
const axios_1 = __importDefault(require("axios"));
exports.VD_CUSTOMER_ORDER_BFF = process.env.VOLDEMORT_BASE_URL || process.env.REACT_APP_VOLDEMORT_BASE_URL;
exports.CUSTOMER_ORDERS_URL = 'v1/customer';
exports.requestCustomerOrderBff = axios_1.default.create({
    baseURL: exports.VD_CUSTOMER_ORDER_BFF,
});
const makeCustomerOrderFeedbackUrl = (orderId, customerId) => `${exports.CUSTOMER_ORDERS_URL}/${customerId}/orders/${orderId}/feedback`;
exports.makeCustomerOrderFeedbackUrl = makeCustomerOrderFeedbackUrl;
/**
 * Cria uma função que atualiza o score de avaliação para um determinado pedido.
 *
 * @param {string} orderId - A ID do pedido a ser atualizado.
 * @param {object} object - Objeto contendo a nota e comentário. Podem ser nulos.
 * @param {ScoreType} object.item - A nota a ser atualizada.
 * @param {string} object.comment - O comentário a ser atualizado.
 * @return {Promise<any>}
 */
const makeUpdateOrderReviewScore = (orderId) => ({ customerId, score, comment, }) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = {};
    if (score) {
        payload.point = score;
    }
    else if (score === null) {
        payload.point = null;
    }
    if (comment) {
        payload.comment = comment;
    }
    return exports.requestCustomerOrderBff
        .patch((0, exports.makeCustomerOrderFeedbackUrl)(orderId, customerId), payload)
        .then((res) => res.data)
        .catch((error) => { var _a; return Promise.reject((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data); });
});
exports.makeUpdateOrderReviewScore = makeUpdateOrderReviewScore;
const makeUpdateDeliveryStatusUrl = (orderId, customerId) => `${exports.CUSTOMER_ORDERS_URL}/${customerId}/orders/${orderId}/delivery`;
exports.makeUpdateDeliveryStatusUrl = makeUpdateDeliveryStatusUrl;
const updateOrderDeliveryStatus = ({ orderId, customerId, deliveryStatus, }) => __awaiter(void 0, void 0, void 0, function* () {
    if (!orderId || !deliveryStatus) {
        throw new Error('Missing parameters');
    }
    const data = JSON.stringify({
        status: deliveryStatus,
    });
    return exports.requestCustomerOrderBff
        .post((0, exports.makeUpdateDeliveryStatusUrl)(orderId, customerId), data, {
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then((res) => res.data)
        .catch(() => {
        throw new Error('Error trying to update order delivery status');
    });
});
exports.updateOrderDeliveryStatus = updateOrderDeliveryStatus;
